// src/hooks/useSync.js
import { useEffect, useRef } from "react";
import { syncToFirestore, syncFromFirestore } from "../services/storageBridge";

// [refresh] Ce hook synchronise local <-> Firestore dès qu'un utilisateur est connecté
export default function useSync(user) {
  const syncRunning = useRef(false);

  useEffect(() => {
    if (!user?.uid) return;

    console.log("[repeat] Sync system started for:", user.uid);

    const items = [
      { key: "relations_settings", col: "relations" },
      { key: "dossiers_settings", col: "dossiers" },
      { key: "dossier_records", col: "dossier_records" },

      // download-only
      { key: "all_modeles", col: "modeles" },
    ];

    // Upload items: exclut all_modeles (download-only)
    // On inclut *_settings car syncToFirestore gère maintenant leur upload
    const uploadItems = items.filter((it) => it.key !== "all_modeles");

    // 1) Pull systématique au login (merge remote/local) - AWAIT pour compléter avant interval
    (async () => {
      for (const { key, col } of items) {
        try {
          await syncFromFirestore(user.uid, key, col);
        } catch (err) {
          console.warn("[warning] syncFromFirestore", key, err?.message || err);
        }
      }
      console.log("[ok] Initial sync pull completed");
    })();

    // 2) Boucle: pull puis push toutes les 5 min
    const interval = setInterval(async () => {
      // Prévenir les exécutions concurrentes
      if (syncRunning.current) {
        console.log("[skip] Sync interval skipped (previous sync still running)");
        return;
      }

      syncRunning.current = true;
      try {
        // Pull pour tous les items
        for (const { key, col } of items) {
          try {
            await syncFromFirestore(user.uid, key, col);
          } catch (err) {
            console.warn("[warning] interval syncFromFirestore", key, err?.message || err);
          }
        }

        // Push pour uploadItems (collections + settings)
        for (const { key, col } of uploadItems) {
          try {
            await syncToFirestore(user.uid, key, col);
          } catch (err) {
            console.warn("[warning] interval syncToFirestore", key, err?.message || err);
          }
        }
      } finally {
        syncRunning.current = false;
      }
    }, 300000); // 5 minutes

    return () => clearInterval(interval);
  }, [user?.uid]);
}
